// Android WebViews (WhatsApp, Instagram, Facebook, etc.) consistently include
// either "wv" or "Version/4.0" in their UA — real Chrome never has "Version/4.0".
export const isAndroidWebView = (): boolean => {
  const ua = navigator.userAgent
  if (!/Android/i.test(ua)) return false
  return /wv\b/i.test(ua) || /Version\/4\.0/i.test(ua)
}

export const isIOS = (): boolean =>
  /iPad|iPhone|iPod/i.test(navigator.userAgent)

export const isWhatsAppWebView = (): boolean =>
  /whatsapp/i.test(navigator.userAgent) || isAndroidWebView()

export const isWebView = (): boolean =>
  isWhatsAppWebView() ||
  /instagram|fbav|fban|FBAN|FBAV/i.test(navigator.userAgent)
